import { PDC_OVERDUE_AFTER_DAYS } from '@/constants';

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export const getOverdueThreshold = () => Date.now() - PDC_OVERDUE_AFTER_DAYS * MILLISECONDS_PER_DAY;

export const isOverdue = (modificationTimestamp: number | string | undefined) =>
    new Date(modificationTimestamp ?? Number.NaN).getTime() < getOverdueThreshold();
